export const XRSTATE_IN_XR = 'XRSTATE_IN_XR';
export const XRSTATE_ENTERING_XR = 'XRSTATE_ENTERING_XR';
export const XRSTATE_EXITING_XR = 'XRSTATE_EXITING_XR';
export const XRSTATE_NOT_IN_XR = 'XRSTATE_NOT_IN_XR';

export const SEARCH_MODE_SEACRHING = 'SEARCH_MODE_SEACRHING';

export const MAINBUS_TOGGLE_FSM = 'MAINBUS_TOGGLE_FSM';

export const SEARCH_TELEPORT_COMPLETE = 'SEARCH_TELEPORT_COMPLETE';
export const TOUR_TELEPORT_COMPLETE = 'TOUR_TELEPORT_COMPLETE';

export const MAINBUS_SET_SEARCH_ACTIVE_SS = 'MAINBUS_SET_SEARCH_ACTIVE_SS';
export const MAINBUS_SET_SEARCH_SELECTED_RESULT =
  'MAINBUS_SET_SEARCH_SELECTED_RESULT';
export const MAINBUS_SET_SEARCH_SCROLL_POSITION =
  'MAINBUS_SET_SEARCH_SCROLL_POSITION';

export const LOAD_NEW_SHELL = 'LOAD_NEW_SHELL';
export const NEW_SHELL_LOAD_COMPLETE = 'NEW_SHELL_LOAD_COMPLETE';

export const MAINBUS_SET_SEARCHSTRING = 'MAINBUS_SET_SEARCHSTRING';
export const MAINBUS_SET_SEARCH_SEARCHING = 'MAINBUS_SET_SEARCH_SEARCHING';
export const MAINBUS_SET_SEARCH_RESULTS = 'MAINBUS_SET_SEARCH_RESULTS';
export const SEARCH_RESET = 'SEARCH_RESET';
export const OPEN_SEARCH_SIDEPANEL = 'OPEN_SEARCH_SIDEPANEL';

//* TOUR MODE
export const START_TOUR_MODE = 'START_TOUR_MODE';
export const END_TOUR_MODE = 'END_TOUR_MODE';
export const NEXT_ITEM_TOUR_MODE = 'NEXT_ITEM_TOUR_MODE';
export const PREV_ITEM_TOUR_MODE = 'PREV_ITEM_TOUR_MODE';
export const SEARCH_TWODVIEW = 'SEARCH_TWODVIEW';
export const SEARCH_THREEDVIEW = 'SEARCH_THREEDVIEW';

/**
 * This an an example of commenting an event for clearity. It will show up when
 * hovering over this event constant elsewhere. If the event has any parameters, they
 * should be listed here. Ex:
 * @property {string} exampleString This is an example of an event with a argument
 */
export const ENTER_WEBXR_REQUESTED = 'ENTER_WEBXR_REQUESTED';

/**
    The babylon scene, camera, engine are available under window.bitreel once this event is emitted.
*/
export const BABYLON_LOADING_FINISHED = 'BABYLON_LOADING_FINISHED';
export const BITSTREAM_FIRSTRUN_COMPLETE = 'BITSTREAM_FIRSTRUN_COMPLETE';
/**
    Download worker constants
*/
export const WORKERS_INIT_STARTED = 'WORKERS_INIT_STARTED';
export const WORKERS_INIT_FINISHED = 'WORKERS_INIT_FINISHED';

export const SET_CURRENT_SELECTED_SEARCH_RESULT =
  'SET_CURRENT_SELECTED_SEARCH_RESULT';
/**
    Loading Screen events
*/

export const MAINBUS_SHOW_CENTER_MESSAGE = 'MAINBUS_SHOW_CENTER_MESSAGE';

export const CAMERA_INITIAL_POSITION_SET = 'CAMERA_INITIAL_POSITION_SET';

export const MAINBUS_CHANGE_SETTING = 'MAINBUS_CHANGE_SETTING';

export const ENTER_BITREEL_BUTTON_PRESSED = 'ENTER_BITREEL_BUTTON_PRESSED';
export const COBROWSE_CLOSE_DETAILS_VIEW = 'COBROWSE_CLOSE_DETAILS_VIEW';

export const CANVAS_CLICKED = 'CANVAS_CLICKED';
export const COBROWSE_CLIENT_JOINED = 'COBROWSE_CLIENT_JOINED';
export const COBROWSE_CLIENT_DISCONNECTED = 'COBROWSE_CLIENT_DISCONNECTED';
export const COBROWSE_PLAYER_INFO_UPDATED = 'COBROWSE_PLAYER_INFO_UPDATED';
export const COBROWSE_SELF_INFO_UPDATED = 'COBROWSE_SELF_INFO_UPDATED';
export const COBROWSE_CONNECT_ERROR = 'COBROWSE_CONNECT_ERROR';

export const TELEPORT_SHELL = 'TELEPORT_SHELL';
export const OPEN_SAVED_ITEMS = 'OPEN_SAVED_ITEMS';
export const CLOSE_SAVED_ITEMS = 'CLOSE_SAVED_ITEMS';
export const JOYSTICK_MOVED = 'JOYSTICK_MOVED';
export const JOYSTICK_START = 'JOYSTICK_START';
export const JOYSTICK_END = 'JOYSTICK_END';
export const SHOW_BANNERS = 'SHOW_BANNERS';

export const HIDE_BANNERS = 'HIDE_BANNERS';

export const COBROWSER_TELEPORTED = 'COBROWSER_TELEPORTED';

export const SHELL_DATA_LOADED = 'SHELL_DATA_LOADED';
export const MAINBUS_DATA_READY = 'MAINBUS_DATA_READY';

export const GAZED_NEW_PRODUCT = 'GAZED_NEW_PRODUCT';
export const COBROWSER_DISCONNECTED = 'COBROWSER_DISCONNECTED';

export const SHOWROOM_ITEM_GAZE_OVER_3SEC = 'SHOWROOM_ITEM_GAZE_OVER_3SEC';

export const PRODUCT_SELECTED = 'PRODUCT_SELECTED';
export const PRODUCT_DESELECTED = 'PRODUCT_DESELECTED';

export const CSS_LOADED_INSIDE_SHADOWROOT = 'CSS_LOADED_INSIDE_SHADOWROOT';
export const SHOW_INSTRUCTION = 'SHOW_INSTRUCTION';
export const SHOW_COBROWSING_INVITE_MODAL = 'SHOW_COBROWSING_INVITE_MODAL';
export const INIT_COBROWSING = 'INIT_COBROWSING';
export const SHARE_PRODUCT = 'SHARE_PRODUCT';

export const ENABLE_DETAIL_VIEW = 'ENABLE_DETAIL_VIEW';
export const ENABLE_SHOWROOM_VIEW = 'ENABLE_SHOWROOM_VIEW';
export const ENABLE_AR_VIEW = 'ENABLE_AR_VIEW';

export const UPDATE_DETAIL_VIEW_ANGLE = 'UPDATE_DETAIL_VIEW_ANGLE';

export const COLLISION_LOAD_FINISHED = 'COLLISION_LOAD_FINISHED';

export const CART_CHANGED = 'CART_CHANGED';

export const COBROWSE_SET_CB_REMOTE_CONTROL = 'COBROWSE_SET_CB_REMOTE_CONTROL';

//export const SAVED_ITEM_UPDATED = 'SAVED_ITEM_UPDATED';

export const TOGGLE_PRODUCT_SPEC = 'TOGGLE_PRODUCT_SPEC';

export const SHADOWROOT_SETUP_READY = 'SHADOWROOT_SETUP_READY';
export const SHOW_COBROWSING_SHARE_MODAL = 'SHOW_COBROWSING_SHARE_MODAL';

export const CHANGE_CUSTOMIZATION = 'CHANGE_CUSTOMIZATION';

export const NEW_DETAILS_ITEM_REQUESTED = 'NEW_DETAILS_ITEM_REQUESTED';

export const TOGGLE_PRODUCT_CAROUSEL = 'TOGGLE_PRODUCT_CAROUSEL';

export const SHOW_QR_MODAL = 'SHOW_QR_MODAL';
export const SHOW_ATTACH_MODAL = 'SHOW_ATTACH_MODAL';

export const SHOW_VIDEO_MODAL = 'SHOW_VIDEO_MODAL';
export const SHOW_EXIT_MODAL = 'SHOW_EXIT_MODAL';
export const SHOW_SHOWROOM_TELEPORT_MODAL = 'SHOW_SHOWROOM_TELEPORT_MODAL';
export const DETAILS_ITEM_FIRST_LOD_LOADED = 'DETAILS_ITEM_FIRST_LOD_LOADED';
export const MENU_OPEN = 'MENU_OPEN';
export const CLOSE_ALL_UI = 'CLOSE_ALL_UI';

export const SEARCH_ZOOM_EVENT = 'SEARCH_ZOOM_EVENT';

//Attach event
export const TELEPORT = 'TELEPORT';
export const ATTACH_USER = 'FOLLOW_USER';
export const ATTACHED_BY_USER = 'ATTACHED_BY_USER';
export const DETACH_USER = 'DETACH_USER';

export const FLOOR_MESH_LOADED = 'FLOOR_MESH_LOADED';

//webRTC
export const WEBRTC_INITIALIZED = 'WEBRTC_INITIALIZED';
export const WEBRTC_JOINED_ROOM = 'WEBRTC_JOINED_ROOM';
export const WEBRTC_ROOM_UPDATE = 'WEBRTC_ROOM_UPDATE';
export const WEBRTC_NEW_STREAM = 'WEBRTC_NEW_STREAM';
export const WEBRTC_STREAM_START_PLAY = 'WEBRTC_STREAM_START_PLAY';
export const WEBRTC_STREAM_STATS = 'WEBRTC_STREAM_STATS';

//model-viewer
export const CLOSE_MODEL_VIEWER_UI = 'CLOSE_MODEL_VIEWER_UI';

//customize
export const LAYOUT_REQUEST = 'LAYOUT_REQUEST';
export const LABEL_SELECTED = 'LABEL_SELECTED';
export const TOGGLE_CUSTOMIZE_CAROUSEL = 'TOGGLE_CUSTOMIZE_CAROUSEL';

//ar
export const TEXTURE_LOAD_FINISH = 'TEXTURE_LOAD_FINISH';
export const ITEM_LODS_REQUEST = 'ITEM_LODS_REQUEST';
export const ITEM_PART_REQUEST = 'ITEM_PART_REQUEST';

export const PRODUCT_MANIFEST_LOADED = 'PRODUCT_MANIFEST_LOADED';
export const PRODUCT_DATA_SET_UP_FINISHED = 'PRODUCT_DATA_SET_UP_FINISHED';

export const SAVED_ITEM_INITED = 'SAVED_ITEM_INITED';

//map
export const TOGGLE_MAP_VIEW = 'TOGGLE_MAP_VIEW';

//pdf
export const SHOW_PDF_MODAL = 'SHOW_PDF_MODAL';

//cb
export const SCHEDULE_CB_SESSION = 'SCHEDULE_CB_SESSION';

export const SEARCH_QUERY_FIRED = 'SEARCH_QUERY_FIRED';
export const SEARCH_MENU_PRODUCT_CLICKED = 'SEARCH_MENU_PRODUCT_CLICKED';

export const SAVE_EMAIL_SEND = 'SAVE_EMAIL_SEND';

export const DETAIL_VIEW_END = 'DETAIL_VIEW_END';

export const LOAD_FINISHED = 'LOAD_FINISHED';

export const MAINBUS_SET_APP_METADATA = 'MAINBUS_SET_APP_METADATA';

export const PRODUCT_TELEPORT_CONFIRM = 'PRODUCT_TELEPORT_CONFIRM';

export const BITSTREAM_INITIAL_SECTOR_LOADED =
  'BITSTREAM_INITIAL_SECTOR_LOADED';
export const INITIAL_SECTOR_LOADED = 'INITIAL_SECTOR_LOADED';
export const FIRST_SECTOR_LOADED = 'FIRST_SECTOR_LOADED';
export const SERACH_RESULT_UPDATE = 'SERACH_RESULT_UPDATE';

export const SET_INITIAL_COBROWSE_MESSAGES = 'SET_INITIAL_COBROWSE_MESSAGES';
export const NEW_COBROWSE_MESSAGE = 'NEW_COBROWSE_MESSAGE';

export const START_TUTORIAL = 'START_TUTORIAL';
export const END_TUTORIAL = 'END_TUTORIAL';
export const BITSTREAM_SUCCESSFULLY_PAUSED = 'BITSTREAM_SUCCESSFULLY_PAUSED';
export const BITSTREAM_SUCCESSFULLY_UNPAUSED =
  'BITSTREAM_SUCCESSFULLY_UNPAUSED';
export const BITSTREAM_STARTED_LOADING = 'BITSTREAM_STARTED_LOADING';
export const BITSTREAM_IS_IDLE = 'BITSTREAM_IS_IDLE';

export const TAB_IS_BLURRED = 'TAB_IS_BLURRED';
export const TAB_IS_FOCUSED = 'TAB_IS_FOCUSED';

export const PRODUCT_INFO_CARD_HOVER_ON = 'PRODUCT_INFO_CARD_HOVER_ON';
export const PRODUCT_HOVER_TELEPORT = 'PRODUCT_HOVER_TELEPORT';
export const PRODUCT_INFO_CARD_HOVER_OFF = 'PRODUCT_INFO_CARD_HOVER_OFF';

export const NEW_MANIFEST_LOADED = 'NEW_MANIFEST_LOADED';

export const COBROWSE_SET_ROOM_SESSION_ID = 'COBROWSE_SET_ROOM_SESSION_ID';
export const COBROWSE_REMOTE_CAMERA_POSITION_CHANGED =
  'COBROWSE_REMOTE_CAMERA_POSITION_CHANGED';
export const AUDIO_CONNECTION_FAILED = 'AUDIO_CONNECTION_FAILED';
export const HOST_TELEPORT_REQUEST = 'HOST_TELEPORT_REQUEST';
export const MAINBUS_REQUEST_HELP_JOINED = 'MAINBUS_REQUEST_HELP_JOINED';
export const REQUEST_HELPER_DISCONNECTED = 'REQUEST_HELPER_DISCONNECTED';
export const START_REGULAR_TUTORIAL = 'START_REGULAR_TUTORIAL';
